export interface IAppFile {
  fileType: string;
  fileName: string;
  fileNumber: number;
  publicUrl: string;
  fileSize: number;
}
